import moment from 'moment'

/* Wrapper for common time calls */
export default new class TimeAssistant {
  /* Guesses the timezone ID (from C# TimeZoneInfo) based on client timezone settings */
  public guessTimezoneID(): string {
    const tzDefault = 'UTC'

    try {
      const jsTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

      if (jsTimeZone === null || jsTimeZone === '') {
        return tzDefault
      }

      const tzPacific = ['America/Los_Angeles', 'America/Vancouver']
      const tzMountain = ['America/Denver', 'America/Yellowknife']

      const tzCentral = [
        'America/Chicago',
        'America/Winnipeg',
        'America/Mexico_City',
        'America/Regina',
        'America/Managua',
        'America/Guatemala',
        'America/Monterrey',
      ]

      const tzEastern = [
        'America/Toronto',
        'America/New_York',
        'America/Montreal',
        'America/Indianapolis',
      ]

      const tzHawaii = ['Pacific/Honolulu']
      const tzArizona = ['America/Phoenix']
      const tzAlaska = ['America/Anchorage', 'America/Nome']
      const tzAusEastern = ['Australia/Sydney', 'Australia/Melbourne']
      const tzEAus = ['Australia/Brisbane']
      const tzNewZealand = ['Pacific/Auckland']
      const tzIndia = ['Asia/Calcutta']
      const tzWEurope = ['Europe/Rome', 'Europe/Berlin', 'Europe/Stockholm']
      const tzRomance = ['Europe/Madrid', 'Europe/Paris', 'Europe/Brussels']
      const tzGMT = ['Europe/Dublin', 'Europe/London', 'Europe/Lisbon']

      const tzCEurope = [
        'Europe/Budapest',
        'Europe/Warsaw',
        'Europe/Oslo',
        'Europe/Belgrade',
      ]

      if (tzHawaii.includes(jsTimeZone)) {
        return 'Hawaiian Standard Time'
      }

      if (tzPacific.includes(jsTimeZone)) {
        return 'Pacific Standard Time'
      }

      if (tzMountain.includes(jsTimeZone)) {
        return 'Mountain Standard Time'
      }

      if (tzArizona.includes(jsTimeZone)) {
        return 'US Mountain Standard Time'
      }

      if (tzCentral.includes(jsTimeZone)) {
        return 'Central Standard Time'
      }

      if (tzEastern.includes(jsTimeZone)) {
        return 'Eastern Standard Time'
      }

      if (tzAlaska.includes(jsTimeZone)) {
        return 'Alaskan Standard Time'
      }

      if (tzAusEastern.includes(jsTimeZone)) {
        return 'AUS Eastern Standard Time'
      }

      if (tzEAus.includes(jsTimeZone)) {
        return 'E. Australia Standard Time'
      }

      if (tzNewZealand.includes(jsTimeZone)) {
        return 'New Zealand Standard Time'
      }

      if (tzIndia.includes(jsTimeZone)) {
        return 'India Standard Time'
      }

      if (tzWEurope.includes(jsTimeZone)) {
        return 'W. Europe Standard Time'
      }

      if (tzRomance.includes(jsTimeZone)) {
        return 'Romance Standard Time'
      }

      if (tzGMT.includes(jsTimeZone)) {
        return 'GMT Standard Time'
      }

      if (tzCEurope.includes(jsTimeZone)) {
        return 'Central Europe Standard Time'
      }
      return tzDefault
    } catch {
      return tzDefault
    }
  }

  public formatDateToDateAndTime(date: any): string {
    return date ? moment(date).format('MMM D, YYYY h:mm A') : ''
  }
}()
